export const DETAIL_COURSE_REQUEST =
  "@DetailCourseReducer/DETAIL_COURSE_REQUEST";
export const DETAIL_COURSE_SUCCESS =
  "@DetailCourseReducer/DETAIL_COURSE_SUCCESS";
export const DETAIL_COURSE_FAILED = "@DetailCourseReducer/DETAIL_COURSE_FAILED";
